import { Button, Spinner } from "react-bootstrap";

export const ButtonSpinnerComponent = ({
  onClick,
  children,
  loading,
  loadingText,
  ...rest
}: any) => {
  return (
    <Button onClick={onClick} disabled={loading} {...rest}>
      {loading ? (
        <>
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
            className={loadingText ? "me-2" : ""}
          />
          {loadingText || null}
        </>
      ) : (
        children
      )}
    </Button>
  );
};
